export const statusMatching = (status) => {
  switch (status) {
    case 'SUBMITTED':
      return { text: 'Submitted', bg: '#FEF3C7', color: '#F27D00' };
    case 'REJECTED':
      return { text: 'Rejected', bg: '#FEE2E2', color: '#C71818' };

    case 'APPROVED':
      return { text: 'Complete', bg: '#DCFCE7', color: '#174A2A' };

    case 'PENDING_APPROVAL':
      return { text: 'In Progress', bg: '#FEF3C7', color: '#F27D00' };

    case 'FAILED':
      return { text: 'Failed', bg: '#FEE2E2', color: '#C71818' };

    default:
      return { text: 'N/A', bg: '#F3F3F3', color: '#6b6b6bff' };
  }
};

export const statusReverseMatching = (status) => {
  switch (status) {
    case 'Submitted':
      return 'SUBMITTED';

    case 'Rejected':
      return 'REJECTED';

    case 'Complete':
      return 'APPROVED';

    case 'In Progress':
      return 'PENDING_APPROVAL';

    case 'Failed':
      return 'FAILED';

    case 'N/A':
      return 'none';

    default:
      return '';
  }
};

export const localNerisStatusMatching = (status) => {
  switch (status) {
    case 'progress':
      return { text: 'In Progress', bg: '#FEF3C7', color: '#F27D00' };
    case 'new':
      return { text: 'New', bg: '#FEE2E2', color: '#C71818' };

    case 'validated':
      return { text: 'Finished', bg: '#DCFCE7', color: '#174A2A' };

    default:
      return { text: 'N/A', bg: '#F3F3F3', color: '#6b6b6bff' };
  }
};

export const localNerisStatusReverseMatching = (status) => {
  switch (status) {
    case 'In Progress':
      return 'progress';

    case 'New':
      return 'new';

    case 'Finished':
      return 'validated';

    default:
      return '';
  }
};

export const callStatusColorMatching = (status) => {
  switch (status) {
    case 'closed':
      return { bg: '#DCFCE7' };
    case 'open':
      return { bg: '#FFF89A' };

    case 'reviewed':
      return { bg: 'rgba(0, 112, 156, 0.506)' };

    default:
      return { bg: 'none' };
  }
};
